import React, { Component } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faFileAlt,
    faParagraph
} from "@fortawesome/free-solid-svg-icons";

class FooterBox extends Component {

    constructor(props) {
        super(props);
    }



    render() {
        return (
<div style={{width:'100%',background:'#4b4a45', color:'white',textAlign:"center", padding:'0.5em',marginTop:'1em'}}>
                                    <a target={'_blank'} style={{textDecoration: 'none',color:'#fff'}} href='https://bauabc.de/impressum'><FontAwesomeIcon icon={faParagraph}></FontAwesomeIcon> Impressum</a> | <a target={'_blank'} style={{textDecoration:'none',color:'#fff'}} 
                                    href='https://bauabc.de/datenschutzerklaerung-my-ausbildung-cloud'><FontAwesomeIcon icon={faFileAlt}></FontAwesomeIcon> Datenschutzerklärung</a>
                                </div>
        )
    }
}


export default FooterBox;
